import {Types} from "../actions/videoActions";

const videoReducers = (state, action) => {
  switch (action.type) {
    case Types.VIDEO_UPDATED_COMPLETION: {
      let newState = {...state};
      console.log('newState.courseCompletion',newState.courseCompletion)
      const newCompletion = [...newState.courseCompletion]

      const courseIndex = newCompletion.find(i => i.id == action.video.id)

      if (courseIndex == -1){
        newCompletion.push(action.video)
      } else {
        newCompletion[courseIndex] = action.video
      }

      newState.courseCompletion = newCompletion

      return newState;
    }
    case Types.VIDEO_COURSE_COMPLETION: {
      let newState = {...state};
      newState.courseCompletion = action.payload;
      return newState;
    }
    default:
      return state;
  }
};

export default videoReducers;